export const MIN_LOAD_CENTS = 500;
export const DAILY_LOAD_CAP_CENTS = 200000;

// Whole-dollar amounts render without cents ($5); cents only appear when the user typed them.
export const formatAmountTrimmed = (amountCents: number): string => {
  const hasCents = amountCents % 100 !== 0;
  return `$${(amountCents / 100).toLocaleString('en-US', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  })}`;
};

export const parseAmountToCents = (amount: number | undefined): number | null =>
  amount === undefined || !Number.isFinite(amount) ? null : Math.round(amount * 100);

export function validateLoadAmount({
  amountCents,
  loadedTodayCents = 0,
  minAmountCents = MIN_LOAD_CENTS,
  dailyCapCents = DAILY_LOAD_CAP_CENTS,
}: {
  amountCents: number | null;
  loadedTodayCents?: number;
  minAmountCents?: number;
  dailyCapCents?: number;
}): string | null {
  if (amountCents === null) {
    return null;
  }
  if (amountCents < minAmountCents) {
    return `Enter at least ${formatAmountTrimmed(minAmountCents)}`;
  }
  const remainingDailyCents = dailyCapCents - loadedTodayCents;
  if (amountCents > remainingDailyCents) {
    const alreadyAddedContext =
      loadedTodayCents > 0 ? `since you've already added ${formatAmountTrimmed(loadedTodayCents)}, ` : '';
    return `Daily limit is ${formatAmountTrimmed(
      dailyCapCents
    )} — ${alreadyAddedContext}you can add up to ${formatAmountTrimmed(Math.max(remainingDailyCents, 0))} more today`;
  }
  return null;
}
